export const html = {
    set(html, { elem }) {
        elem.innerHTML = `${html}`;
    },
};
//# sourceMappingURL=html.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6/es/registry/attr/html.js
// module id = null
// module chunks = 